"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = void 0;
const baseColors_1 = __importDefault(require("./baseColors"));
exports.colors = {
    ...baseColors_1.default,
    body: {
        background: baseColors_1.default.neutral.colorLightest,
        text: baseColors_1.default.neutral.colorDark,
    },
    Icon: {
        locked: baseColors_1.default.neutral.colorMedium,
        disabled: baseColors_1.default.neutral.colorLight,
        enabled: baseColors_1.default.brandcolor.primaryMedium,
    },
    Label: {
        default: baseColors_1.default.neutral.colorDarkest,
        enabled: baseColors_1.default.neutral.colorMedium,
        error: baseColors_1.default.feedbackError.colorLight,
        success: baseColors_1.default.feedbackSuccess.colorLight,
        warning: baseColors_1.default.brandcolor.primaryLight,
    },
    Legend: {
        default: baseColors_1.default.neutral.colorMedium,
    },
    Subtitle: {
        default: baseColors_1.default.neutral.colorDarkest,
    },
    CarMaker: {
        default: baseColors_1.default.neutral.colorDarkest,
    },
    Badge: {
        disabled: baseColors_1.default.neutral.colorLight,
        enabled: baseColors_1.default.brandcolor.primaryMedium,
    },
    Input: {
        background: baseColors_1.default.neutral.colorWhite,
        text: {
            disabled: baseColors_1.default.neutral.colorLight,
            enabled: baseColors_1.default.neutral.colorDark,
            error: baseColors_1.default.feedbackError.colorLight,
            locked: baseColors_1.default.neutral.colorMedium,
            success: baseColors_1.default.feedbackSuccess.colorLight,
            warning: baseColors_1.default.brandcolor.primaryLight,
        },
    },
    FormControl: {
        background: baseColors_1.default.neutral.colorWhite,
        text: {
            disabled: baseColors_1.default.neutral.colorLight,
            enabled: baseColors_1.default.neutral.colorDark,
            error: baseColors_1.default.feedbackError.colorLight,
            locked: baseColors_1.default.neutral.colorMedium,
            success: baseColors_1.default.feedbackSuccess.colorLight,
            warning: baseColors_1.default.brandcolor.primaryLight,
        },
    },
    LegalTerms: baseColors_1.default.neutral.colorMedium,
    Select: {
        active: baseColors_1.default.brandcolor.primaryMedium,
        disabled: baseColors_1.default.neutral.colorLight,
        enabled: baseColors_1.default.neutral.colorDark,
        error: baseColors_1.default.feedbackError.colorLight,
        locked: baseColors_1.default.neutral.colorMedium,
        selected: baseColors_1.default.neutral.colorDark,
    },
};
//# sourceMappingURL=colors.js.map